import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { startsWith } from 'lodash-es';

import { RecourseBookingModel } from '../../content/recourse-booking/model/recourse-booking-model';
import { RecourseBookingUrlConstants } from '../../content/recourse-booking/recourse-booking-url-constants';
import { RecourseBookingStore } from '../booking/recourse-booking-store';
import { RouterService } from '../router-service/router-service';

@Injectable({
  providedIn: 'root',
})
export class BookingRoutingService {
  private readonly router = inject(Router);
  private readonly recourseBookingStore = inject(RecourseBookingStore);
  private readonly routerService = inject(RouterService);

  public openBookingsOverview(): void {
    this.router.navigate([`/${RecourseBookingUrlConstants.MAIN_PATH}/${RecourseBookingUrlConstants.OVERVIEW_TAB}`]);
  }

  public openBookingDetailsView(bookingId: number): void {
    this.router.navigate([
      `/${RecourseBookingUrlConstants.MAIN_PATH}/${RecourseBookingUrlConstants.DETAILS_TAB}/${bookingId}`,
    ]);
  }

  public openBookingDetailsEdit(bookingId: number): void {
    this.router.navigate([
      `/${RecourseBookingUrlConstants.MAIN_PATH}/${RecourseBookingUrlConstants.EDIT_TAB}/${bookingId}`,
    ]);
  }

  public createNewBooking(referencedBooking?: RecourseBookingModel, commingFrom?: string): void {
    if (commingFrom) {
      this.routerService.setPreviousUrl(commingFrom);
    }
    this.recourseBookingStore.setNewCorrectionBookingData(referencedBooking);
    this.router.navigate([`/${RecourseBookingUrlConstants.MAIN_PATH}/${RecourseBookingUrlConstants.NEW_TAB}`]);
  }

  public isEditTabActive(): boolean {
    return startsWith(
      this.router.url,
      `/${RecourseBookingUrlConstants.MAIN_PATH}/${RecourseBookingUrlConstants.EDIT_TAB}`,
    );
  }

  public isViewTabActive(): boolean {
    return startsWith(
      this.router.url,
      `/${RecourseBookingUrlConstants.MAIN_PATH}/${RecourseBookingUrlConstants.DETAILS_TAB}`,
    );
  }

  public isNewTabActive(): boolean {
    return this.router.url === `/${RecourseBookingUrlConstants.MAIN_PATH}/${RecourseBookingUrlConstants.NEW_TAB}`;
  }
}
